import Cookies from "js-cookie";
import { TweenMax } from "gsap";

export default class CookiesPlugin {
    /**
     *
     * @param {object} options
     */

    constructor(options) {
        const _defaults = {
            cookieAccept: ".js-cookie-accept",
            cookieBar: ".js-cookie-bar",
        };

        this.defaults = Object.assign({}, _defaults, options);
        this.init();
    }

    getCookieBar() {
        // return $(this.defaults.cookieBar);
        return document.querySelector(this.defaults.cookieBar);
    }

    getCookieAccept() {
        // return $(this.defaults.cookieAccept);
        return document.querySelector(this.defaults.cookieAccept);
    }

    init() {
        //console.log('Cookies init()');

        TweenMax.to(this.getCookieBar(), 0.4, {
            autoAlpha: 1,
            ease: Sine.easeInOut,
        });

        this.getCookieAccept().addEventListener("click", (ev) => {
            ev.preventDefault();

            const name = ev.currentTarget.dataset.name;
            const value = ev.currentTarget.dataset.value;

            this.closeCookies(name, value);
        });

        if (document.cookie.indexOf("cookie.acceptance") >= 0 || this.isFacebookApp()) {
            // They've been here before.
            const elem = this.getCookieBar();
            elem.parentNode.removeChild(elem);
        }
    }

    isFacebookApp() {

        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return(ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    }

    closeCookies(name, value) {

        Cookies.set(name, value, {
            expires: 365,
            path: "/",
        });

        TweenMax.to(this.getCookieBar(), 0.4, {
            autoAlpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this.getCookieBar().remove();
            },
            y: 40,
        });
    }
}
